export class PromotoraFiltroDTO {
    matriz?: string;
    codigo?: string;
    nome?: string;
    nomeFantasia?: string;
    cnpj?: string;
    cidade?: string;
    ativo?: string;
    ids?: number[];
}